import React from "react";
import PropTypes from "prop-types";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Link from "components/link";
import IconButton from "components/icon-button";
import { FormattedMessage } from "react-intl";
import Icon from "components/icon";
import { ConnectedPaginatedTable, TableIconCell, CustomTableRow } from "components/table";
import query from "./query";
import { HeaderCell } from "components/table";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import mutation from "./mutation";
import { useMutation } from "@apollo/react-hooks";
import { useCurrentCustomerContext } from "components/current-customer-context";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import { isMobileOnly } from "react-device-detect";
import { SecondCoachButtonWithModal } from "components/buttons";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="app.page.deployment" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const RowComponent = ({ classes, item, refetchData }) => {
  const [deleteDeployment] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();
  const detailsUrl = `/deployment/details/${item.id}`;

  return (
    <CustomTableRow key={item.id} href={detailsUrl}>
      <TableCell>
        <div className={classes.title}>{item.codename}</div>
        <div>{item.description}</div>
        {!isMobileOnly && <div>{item.place.address}</div>}
      </TableCell>
      <TableIconCell>
          <Link href={detailsUrl} target="_blank" rel="noopener">
              <IconButton>
                  <Icon name="launch" />
              </IconButton>
          </Link>
        {item.secondCoachUrl && <SecondCoachButtonWithModal onlyIcon secondCoachUrl={item.secondCoachUrl} />}
        <Restricted permissions={[permissions.deployment_manage]}>
          <Link href={`/deployment/edit/${item.id}`}>
            <IconButton>
              <Icon name="edit" />
            </IconButton>
          </Link>
          <DeleteActionWithModal
            mutation={deleteDeployment}
            mutationVariables={{
              deploymentId: item.id,
              customerId: currentCustomerId,
            }}
            descriptionText="app.deployment.dialog.delete.text"
            elementNameInResult="deleteDeployment"
            elementToDelete={item.codename}
            refetchDataOnSuccess
            refetchData={refetchData}
          />
        </Restricted>
      </TableIconCell>
    </CustomTableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   * Función de refetch de datos
   */
  refetchData: PropTypes.func.isRequired,
};

const StyledRowComponent = withStyles(styles)(RowComponent);

const DeploymentPaginatedTable = props => {
  return (
    <ConnectedPaginatedTable
      gqlQuery={query}
      headerComponent={Header}
      rowComponent={StyledRowComponent}
      paginatedElementsHandler={data => data.deployments}
      {...props}
    />
  );
};

DeploymentPaginatedTable.propTypes = {
  /**
   ** Página a cargar en la tabla
   **/
  page: PropTypes.number,
  /**
   ** Callback que se llama cuando la tabla está vacía
   **/
  onEmpty: PropTypes.func,
};

export default DeploymentPaginatedTable;
